import React from 'react';

const ContactUs = () => {
    return (
        <div>
            <h1>This is Contact Us pages</h1>
        </div>
    );
};

export default ContactUs;